var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ [_vm.customDefault]: _vm.avatarUrl === _vm.emptySrc || !_vm.src }},[_c('img',{attrs:{"src":_vm.avatarUrl,"width":_vm.width,"height":_vm.height,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }